exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-delete[data-v-16741c78] {\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 9999999;\n}\n.metric-container[data-v-16741c78] {\n  position: relative;\n  padding: 10px;\n  border: 1px solid rgb(181, 181, 181);\n  margin-bottom: 10px;\n}", ""]);

// exports
